import { CategoriesData } from './types'
import client from '../../client'

export const getCategories = () => client.get<CategoriesData>('v1/categories/')
